import '../assets/css/page/about.css';
import { Helmet, HelmetProvider } from "react-helmet-async";
import AboutBg from '../assets/img/about-bg.png';
import AboutInfo from "../components/Container/About/aboutInfo";
import WhyChooseUs from "../components/Container/About/whychooseus";
import MissionNdValues from "../components/Container/About/missionNdvalues";

const About = () => {
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{"Kadi's Hair Gallery - About Us"}</title>
        </Helmet>
      </HelmetProvider>

      <section className="about-main" style={{ backgroundImage: `url(${AboutBg})` }}>
        {/* Overlay for contrast */}
        <div className="about-overlay"></div>

        <div className="container">
          <div className="about-content fade-in">
            <h1 className="about-heading">About Us</h1>
            <p className="about-tagline">Empowering Beauty, Building Community.</p>
            {/** 
            <ul className="about-path">
              <li>
                <a href="/">Home</a>
              </li>
              <li className="active">About</li>
            </ul>
            */}
          </div>
        </div>
      </section>

      <AboutInfo />
      <WhyChooseUs />
      <MissionNdValues />
    </>
  );
};

export default About;
